/**
 * Asking the 6 digit code in the middle of the work ("step up"). On a remembered device the session
 * has not passed the code (aal1); the server still accepts the workshop data, but a few things need
 * the code in this session: the operator pages, new backup codes, switching it off, and a storage
 * upload if the storage service did not see the device (a fallback, 20261223000000_mfa_trusted_device.sql).
 * The app registers one dialog (StepUpDialog); the store asks it and retries once.
 */
type Handler = () => Promise<boolean>;
let handler: Handler | null = null;

export function setStepUpHandler(h: Handler): () => void {
  handler = h;
  return () => {
    if (handler === h) handler = null;
  };
}

/** Shows the code dialog; true when the code was given (the session is now at aal2). */
export function requestStepUp(): Promise<boolean> {
  return handler ? handler() : Promise.resolve(false);
}
